import { Component, forwardRef, OnInit } from '@angular/core';
import { BaseInputComponent } from '../base-input/base-input.component';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'textadjustmentpicker',
  templateUrl: './textadjustmentpicker.component.html',
  styleUrls: [ './textadjustmentpicker.component.scss' ],
  providers: [ {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => TextadjustmentpickerComponent),
    multi: true
  } ]
})
export class TextadjustmentpickerComponent extends BaseInputComponent implements OnInit {

  selectedValue?: string;
  adjustments: any[] = [
    {
      icon: 'textalignLeft',
      value: 'left'
    },
    {
      icon: 'textalignCenter',
      value: 'center'
    },
    {
      icon: 'textalignRight',
      value: 'right'
    },
    {
      icon: 'textalignJustify',
      value: 'justify'
    },
  ];

  onSelect(newValue) {
    this.selectedValue = newValue;
    this.form.controls[this.formControlName].setValue(newValue);
    this.onChange();
  }

  ngOnInit(): void {
    this.selectedValue = this.form.controls[this.formControlName].value;
    // this.form.controls[this.formControlName].valueChanges.subscribe( () => this.onChange() );
    super.ngOnInit();
  }

  onChange() {
    if (!this.innerValue) {
      this.selectedValue = null;
    }
    this.selectedValue = this.innerValue;
    super.onChange({ target: { value: this.selectedValue } });
  }
}
